<app-import-nav />
<h5 class="mt-3">Import ARS Consult Notes</h5>

<div class="g-0" [hidden]="uploading">
  <div class="row">
    <div class="col-12">
      @if (hasError) {
        <div class="alert alert-danger">
          There was a problem uploading the file.
          <ul class="mt-2">
            @for (error of errors; track error) {
              <li>{{ error }}</li>
            }
          </ul>
        </div>
      }
      @if (importedCount !== null) {
        <div class="alert alert-success">
          Imported {{ importedCount }} consult note{{ importedCount === 1 ? '' : 's' }}.
        </div>
      }
    </div>
    <div class="col-4">
      <app-file-upload
        [fileType]="'.zip'"
        [uploadButtonLabel]="'Submit'"
        (uploadStart)="onUploadStart()"
        (uploadCancel)="onUploadCancel()"
        (uploadError)="onUploadError()"
        (uploadComplete)="onUploadComplete($event)" />
    </div>
  </div>
</div>
<div class="row g-0" [hidden]="!uploading">
  <div class="col-12">
    <fa-icon [icon]="['fas', 'circle-notch']" size="sm" [animation]="'spin'" />
    Uploading File...
  </div>
</div>
